//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

const URL = import.meta.env.VITE_RENEWAL_API || `${window.location.origin}/renewals`;

export interface ICvRenewalsClient {
	/**
	 * Take up Braintree renewal
	 * @param body (optional) Take up renewal details
	 */
	takeUp(body: TakeUpBraintreeRenewalCommand | undefined): Promise<RenewalTakeupResponse>;
}

export class CvRenewalsClient implements ICvRenewalsClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Take up Braintree renewal
	 * @param body (optional) Take up renewal details
	 */
	takeUp(body: TakeUpBraintreeRenewalCommand | undefined, cancelToken?: CancelToken): Promise<RenewalTakeupResponse> {
		let url_ = this.baseUrl + '/api/v2/CvRenewals/TakeUp';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processTakeUp(_response);
			});
	}

	protected processTakeUp(response: AxiosResponse): Promise<RenewalTakeupResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<RenewalTakeupResponse>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Could not find renewal.', status, _responseText, _headers, result404);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status === 409) {
			const _responseText = response.data;
			let result409: any = null;
			let resultData409 = _responseText;
			result409 = resultData409;
			return throwException(
				'Conflicted state on server e.g. policy is not renewal invited',
				status,
				_responseText,
				_headers,
				result409,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<RenewalTakeupResponse>(null as any);
	}
}

export interface IPaymentClient {
	/**
	 * Make payment intent with Braintree via ICE
	 * @param provider (optional)
	 * @param body (optional) Take up and payment details
	 * @return Payment and policy take up successful
	 */
	makePaymentIntent(
		provider: PaymentProvider | undefined,
		body: MakePaymentIntentCommand | undefined,
	): Promise<PaymentIntentResponse>;
}

export class PaymentClient implements IPaymentClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Make payment intent with Braintree via ICE
	 * @param provider (optional)
	 * @param body (optional) Take up and payment details
	 * @return Payment and policy take up successful
	 */
	makePaymentIntent(
		provider: PaymentProvider | undefined,
		body: MakePaymentIntentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<PaymentIntentResponse> {
		let url_ = this.baseUrl + '/api/v2/Payment/MakePaymentIntent';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				provider: provider !== undefined && provider !== null ? '' + provider : '',
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processMakePaymentIntent(_response);
			});
	}

	protected processMakePaymentIntent(response: AxiosResponse): Promise<PaymentIntentResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<PaymentIntentResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<PaymentIntentResponse>(null as any);
	}
}

export interface IRenewalsClient {
	/**
	 * Take up Braintree renewal
	 * @param body (optional) Take up renewal details
	 */
	takeUp(body: TakeUpBraintreeRenewalCommand | undefined): Promise<RenewalTakeupResponse>;
}

export class RenewalsClient implements IRenewalsClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Take up Braintree renewal
	 * @param body (optional) Take up renewal details
	 */
	takeUp(body: TakeUpBraintreeRenewalCommand | undefined, cancelToken?: CancelToken): Promise<RenewalTakeupResponse> {
		let url_ = this.baseUrl + '/api/v2/Renewals/TakeUp';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processTakeUp(_response);
			});
	}

	protected processTakeUp(response: AxiosResponse): Promise<RenewalTakeupResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<RenewalTakeupResponse>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Could not find renewal.', status, _responseText, _headers, result404);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status === 409) {
			const _responseText = response.data;
			let result409: any = null;
			let resultData409 = _responseText;
			result409 = resultData409;
			return throwException(
				'Conflicted state on server e.g. policy is not renewal invited',
				status,
				_responseText,
				_headers,
				result409,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<RenewalTakeupResponse>(null as any);
	}
}

export enum PaymentProvider {
	STRIPE = 'STRIPE',
	BRAINTREE = 'BRAINTREE',
}

export enum Product {
	PRIVATE_CAR = 'PRIVATE_CAR',
	COMMERCIAL_VEHICLE = 'COMMERCIAL_VEHICLE',
	TELEMATICS = 'TELEMATICS',
	TAXI = 'TAXI',
	CARROT = 'CARROT',
}

export interface MakePaymentIntentCommand {
	policyToken: string;
	saveCard: boolean;
	currencyCode: string;
	amount: number;
	billingAddress: Address;
	clientReturnUrl?: string | undefined;
	product: Product;
}

export interface TakeUpBraintreeRenewalCommand {
	policyToken: string;
	transactionId: string;
	underwrittenOptionId: string;
	paymentOption: PaymentOption;
	idempotencyKey?: string | undefined;
	upFrontSettlementDetails?: BraintreeCardPaymentDetails;
	savedBalanceSettlementDetails?: SavedPaymentMethod;
	newBalanceSettlementDetails?: NewPaymentMethodDetails;
	isFutureStartDate?: boolean;
	startDate?: string;
	existingCardPaymentMethodId?: string | undefined;
	sendPostalDocuments?: boolean;
}

export interface Address {
	line1: string;
	line2?: string | undefined;
	city: string;
	postalCode: string;
	country: string;
}

export interface BraintreeCardPaymentDetails {
	paymentId: string;
	nonce?: string | undefined;
	deviceData?: string | undefined;
}

export interface NewPaymentMethodDetails {
	sortCode: string;
	accountNumber: string;
	bankName: string;
}

export interface PaymentIntentResponse {
	paymentId: string;
	idempotencyKey: string;
	clientIp: string;
}

export enum PaymentOption {
	PayInFull = 'PayInFull',
	FinanceWithoutDeposit = 'FinanceWithoutDeposit',
	FinanceWithDeposit = 'FinanceWithDeposit',
}

export interface SavedPaymentMethod {
	paymentMethodId: string;
}

export interface RenewalTakeupResponse {
	policyReference: string;
}

export interface ProblemDetails {
	type?: string | undefined;
	title?: string | undefined;
	status?: number | undefined;
	detail?: string | undefined;
	instance?: string | undefined;

	[key: string]: any;
}

export class SwaggerException extends Error {
	override message: string;
	status: number;
	response: string;
	headers: { [key: string]: any };
	result: any;

	constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
		super();

		this.message = message;
		this.status = status;
		this.response = response;
		this.headers = headers;
		this.result = result;
	}

	protected isSwaggerException = true;

	static isSwaggerException(obj: any): obj is SwaggerException {
		return obj.isSwaggerException === true;
	}
}

function throwException(
	message: string,
	status: number,
	response: string,
	headers: { [key: string]: any },
	result?: any,
): any {
	if (result !== null && result !== undefined) throw result;
	else throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
	return obj && obj.isAxiosError === true;
}
